<template>
  <div
    v-if="!isLoading"
    class="relative flex flex-col h-screen"
  >
    <TheAppBar
      class="w-full sticky"
      @on-logout="authStore.logoutAndRedirect()"
    />
    <Suspense>
      <router-view />
    </Suspense>
  </div>
</template>

<script lang="ts" setup async>
import { onBeforeMount } from 'vue'
import { useAuth0 } from '@auth0/auth0-vue'

// stores
import { useAuthStore } from '@shared/stores/auth'
import useTopAppBarItemsStore from '@shared/stores/top-app-bar'

// composables
import useAppcuesFlow from '@/composables/useAppcuesFlow'

// components
import TheAppBar from '@/components/AppBar/TheAppBar.vue'
import { CLIENT_ID_KEY, INSTANCE_ID_KEY } from '@shared/helpers/AuthorizationParametersHelper'

const { isLoading, isAuthenticated } = useAuth0()
const authStore = useAuthStore()
const topAppBarItemsStore = useTopAppBarItemsStore()

useAppcuesFlow()

topAppBarItemsStore.update()

onBeforeMount(async () => {
  const params = new URLSearchParams(window.location.search)
  if (params.has('error', 'access_denied')) {
    localStorage.removeItem(INSTANCE_ID_KEY)
    localStorage.removeItem(CLIENT_ID_KEY)
    await authStore.logoutAndRedirect()
    return
  }
  
  if (isAuthenticated.value) {
     authStore.update()
  }

  topAppBarItemsStore.setToUpdatedVersion(false)
})
</script>
